import React, { useState } from 'react';
import {
  Box, TextField, Button, Typography,
  FormControl, InputLabel, Select, MenuItem,
  InputAdornment, OutlinedInput, CircularProgress, Autocomplete
} from '@mui/material';
import axios from 'axios';
import { CurrencySelect } from '../../Recruteur/candidat/AddTalent/CurrencySelect';
import DisponibilitePicker from '../../commun/DisponibilitePicker';
import './Addmission.css';

const StepOne = ({ data, errors, onChange }) => {
  const [autocompleteOptions, setAutocompleteOptions] = useState([]);
  const [loadingAutocomplete, setLoadingAutocomplete] = useState(false);

  const fetchAutocomplete = async (input) => {
    if (!input || input.length < 2) return;
    setLoadingAutocomplete(true);
    try {
      const res = await axios.get('/api/autocomplete', { params: { input } });
      const suggestions = res.data.predictions.map(p => p.description);
      setAutocompleteOptions(suggestions);
    } catch (err) {
      console.error("Erreur autocomplete :", err);
    } finally {
      setLoadingAutocomplete(false);
    }
  };

  return (
    <Box component="form" noValidate className="step-one-form">
      <TextField
        label="Objet"
        required
        value={data.nomMission}
        error={!!errors.nomMission}
        helperText={errors.nomMission}
        onChange={(e) => onChange('nomMission', e.target.value)}
        className="full-width"
      />

      <div className="half-width">
        <Autocomplete
          freeSolo
          options={autocompleteOptions}
          loading={loadingAutocomplete}
          value={data.lieuxTravail}
          onInputChange={(e, newInput) => {
            onChange('lieuxTravail', newInput);
            onChange('regionTravail', newInput);
            fetchAutocomplete(newInput);
          }}
          onChange={(e, value) => {
            onChange('lieuxTravail', value || '');
            onChange('regionTravail', value || '');
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Lieu de travail"
              required
              placeholder="Ex : Paris, Casablanca..."
              error={!!errors.lieuxTravail}
              helperText={errors.lieuxTravail}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingAutocomplete ? (
                      <CircularProgress color="inherit" size={18} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </div>

      <FormControl
        required
        error={!!errors.remuneration}
        className="half-width"
        variant="outlined"
      >
        <InputLabel htmlFor="remuneration">Prime</InputLabel>
        <OutlinedInput
          id="remuneration"
          type="number"
          value={data.remuneration}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              onChange('remuneration', value);
            }
          }}
          endAdornment={
            <InputAdornment position="end">
              <CurrencySelect
                value={data.devise}
                onChange={(value) => onChange('devise', value)}
              />
            </InputAdornment>
          }
          inputProps={{ min: 0 }}
          label="Prime"
        />
        {errors.remuneration && (
          <Typography variant="caption" color="error">
            {errors.remuneration}
          </Typography>
        )}
      </FormControl>

      <FormControl error={!!errors.urgenceMission} className="half-width">
        <InputLabel>Priorité</InputLabel>
        <Select
          value={data.urgenceMission}
          onChange={(e) => onChange('urgenceMission', e.target.value)}
          label="Priorité"
        >
          <MenuItem value="Urgente">Urgente</MenuItem>
          <MenuItem value="À moyen terme">À moyen terme</MenuItem>
          <MenuItem value="Non urgente">Non urgente</MenuItem>
        </Select>
      </FormControl>

      <FormControl error={!!errors.modeTravail} className="half-width">
        <InputLabel>Mode</InputLabel>
        <Select
          value={data.modeTravail}
          onChange={(e) => onChange('modeTravail', e.target.value)}
          label="Mode"
        >
          <MenuItem value="Présentiel">Présentiel</MenuItem>
          <MenuItem value="À distance">À distance</MenuItem>
          <MenuItem value="Hybride">Hybride</MenuItem>
        </Select>
      </FormControl>

      <div className="half-width">
        <DisponibilitePicker
          label="Date de démarrage"
          value={data.dateDebut}
          onChange={(val) => onChange('dateDebut', val)}
          error={!!errors.dateDebut}
          helperText={errors.dateDebut}
        />
      </div>

      <Button
        variant="outlined"
        component="label"
        className="upload-button half-width"
      >
        CHARGER UN DOCUMENT
        <input
          type="file"
          hidden
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) {
              const reader = new FileReader();
              reader.onload = () => {
                onChange('document', {
                  name: file.name,
                  data: reader.result,
                });
              };
              reader.readAsDataURL(file);
            }
          }}
        />
      </Button>

      {data.document && (
        <Typography variant="body2" className="full-width">
          {data.document.name}
        </Typography>
      )}

      <TextField
        label="Contexte de la mission"
        multiline
        minRows={3}
        fullWidth
        required
        value={data.contexteMission}
        error={!!errors.contexteMission}
        helperText={errors.contexteMission}
        onChange={(e) => onChange('contexteMission', e.target.value)}
        className="full-width small-textarea"
      />
    </Box>
  );
};

export default StepOne;
